import React, { Fragment, useState } from "react";
import {
  Box,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { FaInstagram, FaUserClock, FaLinkedinIn } from "react-icons/fa";
import { LoadingButton } from "@mui/lab";
import { IoCall, IoMail } from "react-icons/io5";
import "aos/dist/aos.css";
import { useFormik } from "formik";
import * as yup from "yup";
import BLogo from "../resources/svg/logo.svg";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { LuChevronDown, LuX } from "react-icons/lu";
import countryCodesJson from "../common/json/country.json";
import { FONT_GABRIOLA } from "./constant";
import styled from "@emotion/styled";
import { Slide } from "@mui/material";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: "black",
    },
  },
  "& .Mui-focused": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #DFD1C9B2 !important",
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const validationSchema = yup.object({
  name: yup.string().trim().required("* Name is required"),
  phone: yup
    .string("* Please enter valid number")
    .length(10, "* Please enter valid number")
    .matches(/^[0-9]+$/, "* Please enter valid number")
    .typeError("* Please enter valid number")
    .required("* Phone is Required"),
  message: yup.string().trim().required("* Requirement is required"),
  // subject: yup.string().trim().required("* Subject is required"),
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("* Email is required"),
});

const Footer = ({ formModalOpen, handleFormModalClose }) => {
  const [isLoading, setIsLoading] = useState();

  const handleCloseDialog = () => {
    handleFormModalClose();
    formik.resetForm();
  };

  const featuresLinks = [
    { href: "/", text: "Home" },
    { href: "/privacy-policy", text: "Privacy & Policy" },
    { href: "/terms-and-conditions", text: "Terms & Conditions" },
    // { href: "/disclaimer", text: "Disclaimer" },
  ];
  const addressLinks = [
    {
      href: "tel:+919090298383",
      text: "+91 9090298383",
      icon: <IoCall size={25} />,
    },
    {
      text: "Monday - Saturday 10am- 7:30 pm",
      icon: <FaUserClock size={25} />,
    },
    {
      href: "mailto:sakshi@miraedesigns.in",
      text: "sakshi@miraedesigns.in",
      icon: <IoMail size={25} />,
    },
  ];

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      message: "",
      countryCode: countryCodesJson[97],
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);

      const config = {
        headers: {
          // "Api-Key": process.env.REACT_APP_API_KEY,
          "Api-Key": "c44d1dfa-76be-4bc8-b514-1d27b65d8b66",
        },
      };

      const body = {
        ...values,
        isFromBoketto: true,
        name: values.name,
        email: values.email,
        countryCode: values.countryCode.code,
        phone: values.phone,
        message: values.message,
      };

      axios
        // .post(`${process.env.REACT_APP_API_URL}/contact`, body, config)
        .post(`https://mistri.builders:3034/api/v1/contact`, body, config)
        .then((response) => {
          enqueueSnackbar(response?.data?.message, { variant: "success" });
          setIsLoading(false);
          handleCloseDialog();
        })
        .catch((error) => {
          setIsLoading(false);
        });
    },
  });

  return (
    <>
      <Box
        id="contact"
        sx={{
          paddingTop: { xs: 5 },
          paddingBottom: { md: 2 },
          backgroundColor: "#DFD1C9",
          color: "#FFF",
          paddingX: { lg: 11, md: 8, sm: 4, xs: 2 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{ pl: "0 !important", pr: "0 !important" }}
        >
          <Grid container spacing={6} sx={{ marginBottom: "30px" }}>
            <Grid
              item
              xs={12}
              sm={6}
              md={5}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignContent="center"
            >
              <Box
                display="flex"
                flexDirection="column"
                // alignItems="center"
                // mb={2}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: {
                      xs: 1,
                      sm: 3,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        xs: "150px",
                        sm: "150px",
                        md: "162px",
                      },
                    }}
                  >
                    <img src={BLogo} alt="mb-logo" width="100%" height="100%" />
                  </Box>
                </Box>
              </Box>
              <Typography
                variant="h6"
                color="#444444"
                fontWeight={500}
                maxWidth={{ lg: 472 }}
              >
                Located in Delhi NCR, Haryana, Punjab and Chandigarh-Tricity, we
                are a leading interior design firm dedicated to transforming
                diverse spaces into stunning environments. Contact us today to
                elevate your surroundings with our expert design solutions.
              </Typography>
              <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                <Link
                  href="https://www.instagram.com/miraedesignhouse/"
                  passHref
                  target="_blank"
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#444",
                      borderRadius: "50%",
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    <FaInstagram size={22} />
                  </Box>
                </Link>
                <Link
                  href="https://www.linkedin.com/company/82509337/admin/dashboard/"
                  passHref
                  target="_blank"
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#444",
                      borderRadius: "50%",
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    <FaLinkedinIn size={22} />
                  </Box>
                </Link>

                <Link href="mailto:sakshi@miraedesigns.in" passHref>
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#444",
                      borderRadius: "50%",
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    <IoMail size={22} />
                  </Box>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                sx={{
                  fontWeight: "600",
                  marginBottom: "10px",
                  color: "#444",
                }}
                variant="h3"
              >
                Features
              </Typography>
              <Box sx={{ mt: 3 }}>
                {featuresLinks.map((link, index) => (
                  <Link
                    key={index}
                    href={link.href}
                    passHref
                    target={link.href === "/" ? "_self" : "_blank"}
                    sx={{ textDecoration: "none" }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "400",
                        marginBottom: "10px",
                        color: "#716D64",
                        pl: 0,
                      }}
                      variant="h6"
                    >
                      {link.text}
                    </Typography>
                  </Link>
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Typography
                sx={{
                  fontWeight: "600",
                  marginBottom: "10px",
                  color: "#444",
                  mb: 3,
                }}
                variant="h3"
              >
                Get In Touch
              </Typography>
              <Box sx={{ mt: 3 }}>
                {addressLinks.map((link, index) => (
                  <Link
                    key={index}
                    href={link.href}
                    passHref
                    sx={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                      // pl: 3,
                    }}
                  >
                    {link.icon && (
                      <Box sx={{ width: "30px", color: "#716D64" }}>
                        {link.icon}
                      </Box>
                    )}
                    <Typography
                      sx={{
                        fontWeight: "400",
                        ml: link.icon ? 0 : "45px",
                        marginBottom: "10px",
                        color: "#716D64",
                        display: "flex",
                        gap: "10px",
                      }}
                      variant="h6"
                    >
                      {link.text}
                    </Typography>
                  </Link>
                ))}
              </Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              flexDirection: { md: "row", xs: "column-reverse" },
              justifyContent: "center",
              ml: {
                lg: 5,
                xs: 0,
              },
              mr: {
                lg: 10,
                xs: 0,
              },
            }}
          >
            <Box>
              <Typography
                variant="h6"
                textAlign={"center"}
                sx={{
                  fontWeight: 400,
                  mb: {
                    md: 0,
                    xs: 4,
                  },
                  color: "#444",
                }}
              >
                &copy; {new Date().getFullYear()} Miraé. All rights reserved.
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
      <Dialog
        open={formModalOpen}
        onClose={handleCloseDialog}
        scroll="paper"
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        TransitionComponent={Transition}
        sx={{
          "& .MuiDialog-paper": {
            margin: { xs: "12px", sm: 4 },
            borderRadius: "30px",
          },
        }}
      >
        <DialogTitle id="scroll-dialog-title" sx={{ paddingBottom: 0 }}>
          <Box display={"flex"}>
            <IconButton sx={{ ml: "auto", px: 0 }} onClick={handleCloseDialog}>
              <LuX />
            </IconButton>
          </Box>
          <Box
            sx={{
              textAlign: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="h1"
              color={"#444"}
              fontWeight={400}
              fontFamily={FONT_GABRIOLA}
            >
              Chat First, Bill Never!
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0, px: { xs: 3, sm: 5 } }}>
          <form style={{ paddingTop: "10px" }}>
            <Box>
              <Grid container spacing={2} mb={2}>
                <Grid item xs={12}>
                  <StyledTextField
                    fullWidth
                    type="text"
                    name="name"
                    label="Name"
                    placeholder="Enter name"
                    focused
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={12}>
                  <StyledTextField
                    fullWidth
                    type="email"
                    name="email"
                    label="Email"
                    placeholder="Enter your email"
                    focused
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>
              </Grid>
              <FormControl
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  mt: 1,
                  position: "relative",
                }}
              >
                <Fragment>
                  <Select
                    labelId="countryCode"
                    id="countryCode"
                    label="countryCode"
                    variant="standard"
                    name="countryCode"
                    IconComponent={(props) => (
                      <LuChevronDown size={22} color="#9B9A7C" {...props} />
                    )}
                    renderValue={(selected) => selected.dial_code}
                    onChange={formik.handleChange}
                    value={formik.values.countryCode}
                    sx={{
                      position: "absolute",
                      width: "80px !important",
                      "&.MuiInput-root": {
                        border: "none !important",
                        zIndex: 9,
                        fontWeight: 500,
                        color: "#000",
                        height: "100%",
                        "#countryCode": {
                          textAlign: "center !important",
                        },
                      },
                    }}
                    disableUnderline
                  >
                    {countryCodesJson.map((countryCode, index) => (
                      <MenuItem
                        key={index}
                        value={countryCode}
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          justifyContent: "flex-start",
                        }}
                      >
                        <Typography variant="subtitle2">
                          {countryCode.dial_code}
                        </Typography>
                        <Typography variant="subtitle2">
                          ({countryCode.name})
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "realtive",
                    }}
                  >
                    <Divider
                      orientation="vertical"
                      variant="fullWidth"
                      sx={{
                        height: "50%",
                        borderColor: "#000",
                        borderWidth: "1px",
                        position: "absolute",
                        zIndex: 9,
                        marginLeft: "180px",
                        opacity: 0.4,
                      }}
                    />
                  </Box>
                </Fragment>
                <StyledTextField
                  sx={{
                    ".MuiInputBase-input": {
                      paddingLeft: "100px !important",
                    },
                  }}
                  fullWidth
                  type="text"
                  label="Number"
                  placeholder="Enter your number"
                  focused
                  id="phone"
                  name="phone"
                  variant="outlined"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  onBlur={formik.handleBlur}
                />
              </FormControl>
              {formik.touched.phone && Boolean(formik.errors.phone) && (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "12px",
                    color: "red",
                    ml: 1.5,
                    mt: 0.5,
                    mb: 2,
                  }}
                >
                  {formik.touched.phone && formik.errors.phone}
                </Typography>
              )}
              <Box mt={2}>
                <StyledTextField
                  multiline
                  rows={4}
                  fullWidth
                  type="text"
                  name="message"
                  label="Requirement"
                  placeholder="Write here..."
                  focused
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.message && Boolean(formik.errors.message)
                  }
                  helperText={formik.touched.message && formik.errors.message}
                />
              </Box>
            </Box>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: { xs: 3, sm: 5 }, pt: 3 }}>
          <LoadingButton
            fullWidth
            onClick={formik.handleSubmit}
            variant="contained"
            loading={isLoading}
            loadingIndicator={
              <CircularProgress size={20} sx={{ color: "#9B9A7C" }} />
            }
            sx={{
              px: 8,
              bgcolor: "#9B9A7C",
              borderRadius: "12px",
              height: "48px",
              "&:hover": {
                bgcolor: "#828165",
              },
            }}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Footer;
